export const isMatchingDomain = (domains) => {
  const currentUrl = window.location.href;
  return domains.some((domain) => currentUrl.includes(domain));
};

// Usage example:
// Import the function where needed
// import { isMatchingDomain } from "../../utils/urlUtils";

// Example usage:
export const domains = [
  // "localhost:3000",
  // "dev1learner.shotclasses.com",
  // "qa-learner.shotclasses.com",
  "ltim-sclearner-staging.azurewebsites.net",
  "lighthouse.ltimindtree.com",
  "lighthouse.ltm.com",
];
